import { startOfDay, endOfDay } from '@constants/dayRanger';
import { TWorkingDays } from '@pages/Physicians/components/PhysiciansTable/types';
import { generateTimeBetween } from '@helpers/generateTimeBetween';

export const generateUnavailableSlots = (
  physicianSchedule: TWorkingDays,
  currentWeekDay: string,
  tableData: { value: string }[],
  startTime: string,
  endTime: string,
) => {
  const physicianAvailability = physicianSchedule[currentWeekDay as keyof TWorkingDays];

  if (!physicianAvailability || physicianAvailability.length === 0) {
    return [
      {
        from: startOfDay,
        to: endOfDay,
        stepsInRange: generateTimeBetween(startOfDay, endOfDay).length + 1,
      },
    ];
  }

  const availableRangesAmount = physicianAvailability.length;

  const unavailableSlots = [];

  for (let index = 0; index <= availableRangesAmount; index += 1) {
    const fromTime =
      (index === 0 || availableRangesAmount === 0) &&
      physicianAvailability[index]?.from !== startOfDay
        ? tableData[0].value
        : physicianAvailability[index - 1]?.to;

    const toTime = index <= availableRangesAmount - 1 ? physicianAvailability[index].from : endTime;

    const stepsInRange = () => {
      if (
        availableRangesAmount &&
        endTime === physicianAvailability[availableRangesAmount - 1].to
      ) {
        return 0;
      }
      if (
        availableRangesAmount &&
        startTime === fromTime &&
        endTime === physicianAvailability[0].from
      ) {
        return 0;
      }
      return generateTimeBetween(fromTime, toTime).length;
    };

    unavailableSlots.push({
      from: fromTime,
      to: toTime,
      stepsInRange: endTime ? stepsInRange() + 1 : stepsInRange(),
    });
  }

  return unavailableSlots;
};
